import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useThemeColors } from '../../hooks/useTheme';
import { projects } from '../../data/projects';
import './ProjectDetails.scss';

const ProjectDetails: React.FC = () => {
  const { id } = useParams();
  const colors = useThemeColors();
  const navigate = useNavigate();
  
  const project = projects.find(p => p.id === Number(id));

  if (!project) {
    return (
      <div className="project-not-found">
        <h2>Project not found</h2>
        <button onClick={() => navigate('/')}>Back to Projects</button>
      </div>
    );
  }

  return (
    <section className="project-details" style={{ 
      backgroundColor: colors.background,
      color: colors.primary
    }}>
      <div className="project-details__container">
        <button 
          className="project-details__back-button"
          onClick={() => navigate('/')}
        >
          ← Back to Projects
        </button>

        <div className="project-details__header">
          <div className="project-details__image-wrapper">
            <img
                src={project.image}
                alt={project.title}
                className="project-details__image"
            />
            </div>

          <div className="project-details__header-content">
            <h1>{project.title}</h1>
            <div className="project-details__tags">
              {project.tags.map(tag => (
                <span key={tag} className="project-details__tag">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="project-details__content">
          <div className="project-details__section">
            <h2>Overview</h2>
            <p>{project.details.overview}</p>
          </div>

          <div className="project-details__section">
            <h2>Key Features</h2>
            <ul>
              {project.details.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>

          <div className="project-details__section">
            <h2>Technologies</h2>
            <ul>
              {project.details.technologies.map((tech, index) => (
                <li key={index}>{tech}</li>
              ))}
            </ul>
          </div>

          <div className="project-details__section">
            <h2>Challenges</h2>
            <p>{project.details.challenges}</p>
          </div>

          <div className="project-details__section">
            <h2>Results</h2>
            <p>{project.details.results}</p>
          </div>

          {(project.details.demoUrl || project.details.githubUrl) && (
            <div className="project-details__section">
              <h2>Links</h2>
              <div className="project-details__links">
                {project.details.demoUrl && (
                  <a href={project.details.demoUrl} target="_blank" rel="noopener noreferrer">
                    Live Demo
                  </a>
                )}
                {project.details.githubUrl && (
                  <a href={project.details.githubUrl} target="_blank" rel="noopener noreferrer">
                    GitHub Repository
                  </a>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProjectDetails;